import { useFetchListData } from '@/composables'
import { defineStore } from 'pinia'
import { TransactionMode } from './settings'
import type { AccountData } from './types'

const useAccountOptionStore = defineStore('accountOptions', () => {
  const {
    loading,
    data: accountOptions,
    fetchData,
  } = useFetchListData<AccountData>({
    url: '/api/cash/get_my_wallet_list',
    autoFetch: false,
  })

  const fetchAccountOptions = async (scene: TransactionMode) => {
    return fetchData({ scene })
  }

  const reset = () => {
    loading.value = false
    accountOptions.value = {} as AccountData
  }

  return {
    loading,
    data: accountOptions,
    accountOptions,
    reset,
    fetchAccountOptions,
  }
})

export { useAccountOptionStore }
export default useAccountOptionStore
